module.exports = __webpack_public_path__ + "static/img/lunbo5.32fd4277.webp";